import cn from "classnames";
import { CaretLeft, CaretRight } from "#icons";
import type { Accessor } from "solid-js";

interface ControlsProps {
  className?: string;
  onPrev: () => void;
  onNext: () => void;
  scrollPosition: Accessor<{
    head: number;
    tail?: number | null;
  }>;
  totalItemsCount: number;
  activeItem: Accessor<number>;
}

export function Controls(props: ControlsProps) {
  const { className, totalItemsCount, activeItem, onPrev, onNext, scrollPosition } = props;

  const isPrevDisabled = () => scrollPosition().head === 0;
  const isNextDisabled = () => scrollPosition().tail === 0;

  return (
    <div class={cn("flex items-center text-blue", className)}>
      <button
        class={cn("mr-2 text-3xl", { "cursor-default opacity-50": isPrevDisabled() })}
        onClick={onPrev}
        disabled={isPrevDisabled()}
        aria-label="Previous slide"
        type="button"
        data-tagular={JSON.stringify({
          event: "ElementClicked",
          actionOutcome: "SLIDE",
          outboundUrl: "NULL",
          webElement: {
            location: "SECTION",
            elementType: "BUTTON",
            position: "1",
            text: "PREVIOUS ARROW",
          },
        })}
      >
        <CaretLeft />
      </button>

      <div class="w-24 mx-auto text-center text-sm font-semibold text-black-300">
        {activeItem()} / {totalItemsCount}
      </div>

      <button
        class={cn("text-3xl", { "cursor-default opacity-50": isNextDisabled() })}
        onClick={onNext}
        disabled={isNextDisabled()}
        aria-label="Next slide"
        type="button"
        data-tagular={JSON.stringify({
          event: "ElementClicked",
          actionOutcome: "SLIDE",
          outboundUrl: "NULL",
          webElement: {
            location: "SECTION",
            elementType: "BUTTON",
            position: "0",
            text: "NEXT ARROW",
          },
        })}
      >
        <CaretRight />
      </button>
    </div>
  );
}